var map = {
	"./100hp_gaming_games.svg": 89890,
	"./18-plus.svg": 4179,
	"./1place.svg": 1287,
	"./1spin4win_games.svg": 53760,
	"./2place.svg": 82650,
	"./3place.svg": 62085,
	"./Gaming_Corps_games.svg": 70088,
	"./Igrosoft_games.svg": 60908,
	"./agree.svg": 91923,
	"./agt_games.svg": 24363,
	"./air_screw.svg": 4534,
	"./alert-new.svg": 91116,
	"./alert.svg": 94073,
	"./alert_not_solid.svg": 83443,
	"./amatic_games.svg": 81772,
	"./amigo_games.svg": 6414,
	"./amusnet_games.svg": 63416,
	"./andar-bahar-mobile.svg": 22361,
	"./andar-bahar.svg": 83386,
	"./android.svg": 63042,
	"./apple.svg": 49399,
	"./approved.svg": 7832,
	"./arcade.svg": 42257,
	"./arrow-down.svg": 46997,
	"./arrow-left.svg": 58222,
	"./arrow-right.svg": 64557,
	"./arrow-up.svg": 28826,
	"./arrow_back.svg": 28074,
	"./asian_games.svg": 77971,
	"./atmosfera_games.svg": 67821,
	"./aviator-mobile.svg": 6368,
	"./baccarat.svg": 84682,
	"./back-home.svg": 90092,
	"./back-new.svg": 22709,
	"./back.svg": 42832,
	"./ball-of-basketball.svg": 53208,
	"./basketball.svg": 73584,
	"./belatra_games.svg": 30714,
	"./betgame.svg": 70052,
	"./betgames-mobile.svg": 57265,
	"./betting/bet-check.svg": 1177,
	"./betting/cashout.svg": 24192,
	"./betting/clear-basket.svg": 16371,
	"./betting/error-mobile.svg": 1040,
	"./betting/favorites-filled.svg": 53745,
	"./betting/favorites.svg": 64460,
	"./betting/remove.svg": 79705,
	"./betting/soccer.svg": 78508,
	"./betting/statistics.svg": 31860,
	"./bfgames_games.svg": 90322,
	"./bgaming_games.svg": 97442,
	"./bicycle-sport.svg": 67369,
	"./bingo.svg": 51198,
	"./blackjack.svg": 38559,
	"./bonuses-mobile.svg": 84805,
	"./bonuses_games.svg": 40126,
	"./books.svg": 98961,
	"./bucket.svg": 63647,
	"./buybonus.svg": 99844,
	"./calendar.svg": 52015,
	"./cas-payment.svg": 67285,
	"./cashback.svg": 40277,
	"./casino-mobile.svg": 37495,
	"./categories-more.svg": 72201,
	"./check-2.svg": 97590,
	"./check.svg": 75907,
	"./christmas.svg": 70011,
	"./clear.svg": 29656,
	"./close.svg": 11095,
	"./competition.svg": 99250,
	"./content_copy.svg": 15132,
	"./copy.svg": 15826,
	"./corncob_plane.svg": 63478,
	"./craps.svg": 10256,
	"./crash.svg": 98870,
	"./cricket-x-mobile.svg": 41084,
	"./cricket.svg": 20442,
	"./crossed-eye.svg": 72044,
	"./crypto-icon.svg": 97628,
	"./currencies/AZN.svg": 33796,
	"./currencies/BDT.svg": 61983,
	"./currencies/DOGE.svg": 94052,
	"./currencies/EUR.svg": 36309,
	"./currencies/INR.svg": 94148,
	"./currencies/KGS.svg": 55852,
	"./currencies/KZT.svg": 2380,
	"./currencies/RUB.svg": 43650,
	"./currencies/UAH.svg": 17099,
	"./currencies/USD.svg": 24533,
	"./currencies/UZS.svg": 20197,
	"./dice.svg": 1828,
	"./dog-racing.svg": 60028,
	"./doge.svg": 34666,
	"./done.svg": 10833,
	"./dots.svg": 32065,
	"./download.svg": 43505,
	"./dragon_tiger.svg": 84896,
	"./drops_and_wins.svg": 79623,
	"./easter.svg": 35823,
	"./eastertime.svg": 42036,
	"./edit.svg": 96681,
	"./empty-box.svg": 75756,
	"./endorphina_games.svg": 75707,
	"./error-filled.svg": 49726,
	"./euro_games.svg": 97694,
	"./exchange.svg": 71050,
	"./exclusive.svg": 11615,
	"./exit.svg": 22933,
	"./eye.svg": 56952,
	"./facebook.svg": 34993,
	"./fast.svg": 85515,
	"./fastbet.svg": 22800,
	"./favorites-clear.svg": 20844,
	"./favorites-outline.svg": 18213,
	"./favorites.svg": 6236,
	"./fazi_games.svg": 37273,
	"./fbastards_games.svg": 24673,
	"./filter.svg": 99227,
	"./fishing.svg": 20065,
	"./football.svg": 10286,
	"./formula_spin_games.svg": 38084,
	"./free-speed.svg": 56273,
	"./fruits.svg": 49908,
	"./game-ball.svg": 96383,
	"./gameshows.svg": 46447,
	"./gift-filled.svg": 47788,
	"./gift-icon.svg": 61927,
	"./gift.svg": 57651,
	"./golf.svg": 12077,
	"./green-check.svg": 3769,
	"./halloween.svg": 23790,
	"./heart.svg": 63287,
	"./hi_lo.svg": 49568,
	"./high_five_games.svg": 88552,
	"./home-mobile.svg": 64735,
	"./home.svg": 82924,
	"./horse-racing.svg": 55407,
	"./hot.svg": 89410,
	"./iconic21_games.svg": 6509,
	"./inbet_games.svg": 53357,
	"./indian.svg": 15800,
	"./info-outline.svg": 56276,
	"./info-rounded.svg": 77321,
	"./info-simple.svg": 67432,
	"./info-solid.svg": 9479,
	"./info.svg": 39425,
	"./instagram.svg": 15699,
	"./instant-mobile.svg": 16335,
	"./instant_cashback.svg": 2255,
	"./jackpot.svg": 88769,
	"./jetx.svg": 50582,
	"./jili_games.svg": 27963,
	"./keno-mobile.svg": 88795,
	"./keno.svg": 80664,
	"./key.svg": 51258,
	"./left-feather.svg": 44420,
	"./letter.svg": 21329,
	"./lightning.svg": 16897,
	"./live-casino-mobile.svg": 17888,
	"./live-casino.svg": 26341,
	"./livegames37.svg": 35682,
	"./lock-solid.svg": 64366,
	"./lock.svg": 9808,
	"./logo.svg": 7736,
	"./lotomatic_games.svg": 17657,
	"./lottery-mobile.svg": 49295,
	"./lottery.svg": 92796,
	"./lottery_wheel.svg": 49224,
	"./mail-filled.svg": 39293,
	"./mail.svg": 38688,
	"./main.svg": 54274,
	"./material-symbols_lock-clock.svg": 95033,
	"./medal.svg": 54046,
	"./megaways.svg": 49179,
	"./message-filled.svg": 55159,
	"./message.svg": 29282,
	"./messages.svg": 36093,
	"./mines.svg": 79303,
	"./minus.svg": 72887,
	"./mma.svg": 22168,
	"./mobilesms.svg": 15306,
	"./motorsport.svg": 85314,
	"./netgame_games.svg": 764,
	"./new.svg": 81333,
	"./newyear.svg": 9342,
	"./notification-mobile.svg": 88443,
	"./novomatic_games.svg": 69733,
	"./oktoberfest.svg": 3821,
	"./olympic_games.svg": 91354,
	"./online.svg": 82192,
	"./other.svg": 42321,
	"./others.svg": 84128,
	"./pagination_active.svg": 88226,
	"./pagination_default.svg": 55635,
	"./playson_games.svg": 59757,
	"./plinko.svg": 48094,
	"./plus.svg": 10777,
	"./podium.svg": 25317,
	"./poker.svg": 25012,
	"./pragmatic_games.svg": 89131,
	"./profileApprove.svg": 26035,
	"./profileNotApprove.svg": 99690,
	"./promo-mobile.svg": 65293,
	"./promo.svg": 92718,
	"./promotions.svg": 64903,
	"./providers-cat.svg": 79414,
	"./providers-search.svg": 12562,
	"./refresh.svg": 51110,
	"./results.svg": 47077,
	"./right-feather.svg": 18327,
	"./roulette.svg": 29433,
	"./ruby_play_games.svg": 43294,
	"./rules.svg": 88474,
	"./sand-clock.svg": 82594,
	"./scratch_card.svg": 52790,
	"./search.svg": 213,
	"./send-to-mobilesms.svg": 91041,
	"./slot.svg": 88729,
	"./smartsoft_games.svg": 96388,
	"./sort.svg": 3453,
	"./speed_s.svg": 87596,
	"./spinomenal_games.svg": 17251,
	"./sportgames.svg": 46918,
	"./sports-mobile.svg": 91583,
	"./st_patricks_day.svg": 27893,
	"./stat.svg": 99895,
	"./success.svg": 99350,
	"./summer.svg": 86074,
	"./support.svg": 35198,
	"./table-mobile.svg": 80466,
	"./table.svg": 19,
	"./tadagaming_games.svg": 17362,
	"./technical-works.svg": 79291,
	"./teen_patti.svg": 50514,
	"./telegram.svg": 38088,
	"./tennis.svg": 22488,
	"./threeoaks_games.svg": 95605,
	"./ticket.svg": 85,
	"./time.svg": 52882,
	"./timer-active.svg": 60279,
	"./timer.svg": 20780,
	"./top-wins.svg": 37734,
	"./tournament.svg": 23316,
	"./tournaments-mobile.svg": 35950,
	"./trash.svg": 56401,
	"./trophy-gold-olimp.svg": 25088,
	"./tv_gamess.svg": 88870,
	"./unlock-solid.svg": 77651,
	"./upload.svg": 90054,
	"./user-balance.svg": 28963,
	"./user-filled.svg": 65641,
	"./user.svg": 19476,
	"./valentines_day.svg": 64651,
	"./video_poker.svg": 18908,
	"./virtuals-mobile.svg": 24636,
	"./visa.svg": 1470,
	"./voltent_games.svg": 65779,
	"./vsport.svg": 43561,
	"./wallet-filled.svg": 3963,
	"./wallet.svg": 47054,
	"./warning.svg": 92827,
	"./wifi-off.svg": 19366,
	"./withdrawals.svg": 1227,
	"./worldcup-mobile.svg": 63080,
	"./worldcup.svg": 31629,
	"./zillion_games.svg": 80280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67629;